const menuItems = document.querySelectorAll('.header-menu-list-item');

function closeMenuItem(el) {
    el.classList.remove('active');
    el.querySelector('.header-menu-list-submenu')?.classList.add('max-h-0');
    el.querySelector('.header-menu-list-submenu')?.classList.remove('max-h-max');
    el.querySelector('svg')?.classList.add('-rotate-90');
    el.querySelector('svg')?.classList.remove('rotate-0');
    el.querySelector('.header-menu-list-title[aria-expanded]')?.setAttribute('aria-expanded', 'false');
}

menuItems.forEach((item) => {
    const submenu = item.querySelector('.header-menu-list-submenu');
    const svgIcon = item.querySelector('svg');
    const trigger = item.querySelector('.header-menu-list-title[aria-expanded]');

    if (submenu) {
        item.addEventListener('click', function (event) {
            event.stopPropagation();

            menuItems.forEach((el) => {
                if (el !== item) closeMenuItem(el);
            });

            const willOpen = submenu.classList.contains('max-h-0');
            item.classList.toggle('active');
            submenu.classList.toggle('max-h-0');
            submenu.classList.toggle('max-h-max');
            svgIcon?.classList.toggle('-rotate-90');
            svgIcon?.classList.toggle('rotate-0');
            trigger?.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
    }
});

document.addEventListener('click', function () {
    menuItems.forEach(closeMenuItem);
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        menuItems.forEach(closeMenuItem);
    }
});

// Search CODE

const searchElements = {
    icon: document.getElementById("search-icon"),
    bar: document.getElementById("search-bar"),
    close: document.getElementById("close-search"),
    input: document.getElementById("search-input"),
    resultsList: document.getElementById("search-results-list"),
    searchIcon: document.getElementById("search-action"),
    formSearch: document.getElementById('form-search'),
};

let debounceTimer;

/**
 * Aplica debounce para evitar múltiplas requisições simultâneas
 * @param {Function} callback
 * @param {number} delay
 * @returns {Function}
 */
const debounce = (callback, delay = 300) => {
    return (...args) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => callback(...args), delay);
    };
};

/**
 * Obtém os resultados da busca
 * @param {string} query
 * @returns {Promise<Response>}
 */
const fetchSearchResults = async (query) => {
    const url = `${window.Shopify.routes.root}search/suggest?q=${query}&resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title&section_id=organism-search-suggestion-results`;
    return fetch(url);
};

/**
 * Converte a resposta da busca em HTML
 * @param {Response} response
 * @returns {Promise<Element>}
 */
const parseSearchResults = async (response) => {
    const text = await response.text();
    const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
    return resultsMarkup.querySelector('#predictive-search');
};

/**
 * Atualiza a lista de resultados da busca
 * @param {Element} resultsMarkup
 */
const updateSearchResults = (resultsMarkup) => {
    searchElements.resultsList.innerHTML = "";
    searchElements.resultsList.appendChild(resultsMarkup);
};

const handleSearchInput = debounce(async (event) => {
    const query = event.target.value.trim();
    if (!query) return;
    console.log('Buscando por:', query);
    searchElements.input.value = query;
    try {
        const response = await fetchSearchResults(query);
        if (!response.ok) throw new Error(`${response.status}: ${await response.text()}`);
        const resultsMarkup = await parseSearchResults(response);
        updateSearchResults(resultsMarkup);
        searchElements.resultsList.classList.replace('opacity-0', 'opacity-100');
        StoreUtils.handleScaRef('.search-result-card', false);
    } catch (error) {
        console.error('Erro na busca:', error);
    }
}, 300);

const toggleSearch = () => {
    const isOpen = !searchElements.bar.classList.contains("-top-full");

    if (isOpen) {
        searchElements.bar.classList.add("-top-full", "opacity-0", "transition-all");
        searchElements.bar.classList.remove("m-auto", "h-full", "opacity-100");
        searchElements.bar.classList.remove("p-5");
        searchElements.resultsList.classList.replace("opacity-100", "opacity-0");
        searchElements.input.value = "";
        searchElements.resultsList.innerHTML = "";
        searchElements.input.blur();
        document.body.classList.remove("overflow-hidden");
    } else {
        searchElements.bar.classList.remove("-top-full", "opacity-0");
        searchElements.bar.classList.add("m-auto", "h-full", "opacity-100", "transition-all");
        document.body.classList.add("overflow-hidden");
        searchElements.input.focus();
    }
};

/**
 * Impede o envio do formulário se o campo de busca estiver vazio
 */
const validateAndSubmitSearch = (event) => {
    const query = searchElements.input.value.trim();
    if (!query) {
        event.preventDefault();
        searchElements.input.focus();
    } else {
        const form = searchElements.input.closest("form");
        if (form) {
            form.submit();
        }
    }
};

searchElements.input.addEventListener("input", handleSearchInput);
searchElements.icon.addEventListener("click", toggleSearch);
searchElements.close.addEventListener("click", toggleSearch);
searchElements.searchIcon.addEventListener('click', validateAndSubmitSearch);
searchElements.input.addEventListener("keypress", function (event) {
    if (event.key === "Enter") {
        validateAndSubmitSearch(event);
    }
});
